import React, {Fragment} from 'react';
import AbstractComponent from '../../AbstractComponent';
import Preload from '../../layout/preload/PreloadContent';
import ModalAlerta from '../../layout/modal/ModalAlerta';
import OpcaoPagamentoPagarNaEntrega from './OpcaoPagamentoPagarNaEntrega';

import ClienteModalidadePagamentoService from '../../../service/ClienteModalidadePagamentoService';

import './OpcaoPagamento.css';

class OpcaoPagamento extends AbstractComponent {   
    constructor(props) {
        super(props);

        this.state = {
            preload: false,            

            modalErroMsg: {
                message: '',
                code: 0
            },                                    

            form: {                
                opcaoPagamento: {
                    pagar_na_entrega: [],

                    pagar_no_site: []
                }
            }
        }
    }  

    onPagarNaEntregaChange(lista) {
        let form = this.state.form;
        let opcaoPagamento = form.opcaoPagamento;
        let pagarNaEntrega = opcaoPagamento.pagar_na_entrega;

        pagarNaEntrega = lista;
        opcaoPagamento.pagar_na_entrega = pagarNaEntrega;        
        form.opcaoPagamento = opcaoPagamento;

        this.setState({form: form});
        this.props.onChange(form.opcaoPagamento); 
    } 

    onPagarNoSiteChange(lista) {
        let form = this.state.form;
        let opcaoPagamento = form.opcaoPagamento;
        let pagarNaSite = opcaoPagamento.pagar_no_site;

        pagarNaSite = lista;
        opcaoPagamento.pagar_no_site = pagarNaSite;        
        form.opcaoPagamento = opcaoPagamento;

        this.setState({form: form});
        this.props.onChange(form.opcaoPagamento); 
    }     

    componentDidMount() {
        this.setState({preload: true});

        ClienteModalidadePagamentoService.listar(

        ).then(resposta => {
            let form = this.state.form;

            form.opcaoPagamento = resposta.data;

            this.setState({
                form: form,
                preload: false
            });

            this.props.onUpdate(form.opcaoPagamento);
        }).catch(erro => {
            this.setState({
                modalErroMsg: this.trataErro(erro),
                preload: false
            });
        });
    }    

    showComponent() {
        if(this.state.preload) {
            return (
                <div className="opcaoPagamento">
                    <Preload show={true} />
                </div>
            )
        }

        return (
            <Fragment>
                <div 
                    className="col-md-12
                                col-sm-12
                                col-lg-12
                                col-xs-12
                                text-center"
                    style={{marginBottom: '30px'}}
                >
                    <b>
                        <span style={{fontSize: '18px'}}>
                            Escolha as Opções de Pagamento disponíveis no AppShop
                        </span>
                        
                        <br/>
                        
                        <span style={{color: 'red'}}>
                            (Por padrão, todas as Opções de Pagamentos estão disponíveis)
                        </span>
                    </b>
                </div>   
                                
                <OpcaoPagamentoPagarNaEntrega
                    opcaoPagamento='Pagar na Entrega'
                    lista={this.state.form.opcaoPagamento.pagar_na_entrega}
                    onChange={(lista) => this.onPagarNaEntregaChange(lista)}
                />

                <OpcaoPagamentoPagarNaEntrega
                    opcaoPagamento='Pagar no Site'
                    lista={this.state.form.opcaoPagamento.pagar_no_site}
                    onChange={(lista) => this.onPagarNoSiteChange(lista)}
                />                         
            </Fragment>
        )
    }

    render() {
        return(       
            <Fragment>
                <ModalAlerta
                    show={this.state.modalErroMsg.code !== 0}
                    texto={this.state.modalErroMsg.texto}

                    fechar={() => this.setState({modalErroMsg: this.finalizaErro(this.state.erro)})}
                />

                {this.showComponent()}
            </Fragment>
        )
    }
}

export default OpcaoPagamento;